// Message.js
import React, { useState } from "react";

const defaultFormText = {
  title: "Cuéntanos qué sucedió",
  nameLabel: "Nombre de la reserva",
  arrivalLabel: "Fecha de llegada",
  departureLabel: "Fecha de salida",
  roomLabel: "Habitación (opcional)",
  messageLabel: "Qué sucedió",
  confirmationLabel: "Los datos son correctos",
  cancelButton: "Cancelar",
  sendButton: "Enviar",
  continueButton: "Continuar",
  backButton: "Atrás",
  confirmTitle: "Enviar mensaje",
  confirmMessage:
    "A continuación se abrirá tu app de correo para enviar el mensaje.",
  dateError:
    "La fecha de salida debe ser igual o posterior a la fecha de llegada.",
};

const Message = ({ buttonText = "Mensaje", formText = defaultFormText }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isConfirming, setIsConfirming] = useState(false);
  const [formData, setFormData] = useState({
    guestName: "",
    arrivalDate: "",
    departureDate: "",
    room: "",
    message: "",
    confirmed: false,
  });
  const [dateError, setDateError] = useState("");

  const text = { ...defaultFormText, ...formText };

  const handleChange = (event) => {
    const { name, value, type, checked } = event.target;
    setFormData((currentData) => ({
      ...currentData,
      [name]: type === "checkbox" ? checked : value,
    }));

    if (name === "arrivalDate" || name === "departureDate") {
      setDateError("");
    }
  };

  const closeForm = () => {
    setIsOpen(false);
    setIsConfirming(false);
    setDateError("");
  };

  const createEmailBody = () => {
    const roomValue = formData.room.trim() || "No indicada";

    return [
      "Algo no fue bien",
      "",
      `Nombre de la reserva: ${formData.guestName.trim()}`,
      `Fecha de llegada: ${formData.arrivalDate}`,
      `Fecha de salida: ${formData.departureDate}`,
      `Habitación: ${roomValue}`,
      "",
      "Detalle de lo sucedido:",
      formData.message.trim(),
    ].join("\n");
  };

  const openEmailApp = () => {
    const subject = encodeURIComponent("Algo no fue bien");
    const body = encodeURIComponent(createEmailBody());
    window.location.href = `mailto:rrpp@hotelcondesa.com?subject=${subject}&body=${body}`;
    closeForm();
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (formData.departureDate < formData.arrivalDate) {
      setDateError(text.dateError);
      return;
    }

    setIsConfirming(true);
  };

  return (
    <>
      {/* biome-ignore lint/a11y/useButtonType: <explanation> */}
      <button className="full-width-button" onClick={() => setIsOpen(true)}>
        {buttonText}
      </button>
      {isOpen && (
        <div className="message-modal-overlay" role="presentation">
          <div
            className="message-modal-container"
            role="dialog"
            aria-modal="true"
            aria-labelledby="message-form-title"
          >
            {isConfirming ? (
              <>
                <h2 id="message-form-title">{text.confirmTitle}</h2>
                <p className="message-confirmation-text">
                  {text.confirmMessage}
                </p>
                <div className="message-form-actions">
                  <button
                    type="button"
                    className="secondary-button"
                    onClick={() => setIsConfirming(false)}
                  >
                    {text.backButton}
                  </button>
                  <button
                    type="button"
                    className="full-width-button"
                    onClick={openEmailApp}
                  >
                    {text.continueButton}
                  </button>
                </div>
              </>
            ) : (
              <>
                <h2 id="message-form-title">{text.title}</h2>
                <form className="message-form" onSubmit={handleSubmit}>
                  <label>
                    <span>{text.nameLabel}</span>
                    <input
                      type="text"
                      name="guestName"
                      value={formData.guestName}
                      onChange={handleChange}
                      required
                    />
                  </label>

                  <div className="message-form-dates">
                    <label>
                      <span>{text.arrivalLabel}</span>
                      <input
                        type="date"
                        name="arrivalDate"
                        value={formData.arrivalDate}
                        onChange={handleChange}
                        required
                      />
                    </label>

                    <label>
                      <span>{text.departureLabel}</span>
                      <input
                        type="date"
                        name="departureDate"
                        value={formData.departureDate}
                        min={formData.arrivalDate}
                        onChange={handleChange}
                        required
                      />
                    </label>
                  </div>

                  {dateError && <p className="message-form-error">{dateError}</p>}

                  <label>
                    <span>{text.roomLabel}</span>
                    <input
                      type="text"
                      name="room"
                      value={formData.room}
                      onChange={handleChange}
                    />
                  </label>

                  <label>
                    <span>{text.messageLabel}</span>
                    <textarea
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      rows="5"
                      required
                    />
                  </label>

                  <label className="message-form-confirmation">
                    <input
                      type="checkbox"
                      name="confirmed"
                      checked={formData.confirmed}
                      onChange={handleChange}
                      required
                    />
                    <span>{text.confirmationLabel}</span>
                  </label>

                  <div className="message-form-actions">
                    <button
                      type="button"
                      className="secondary-button"
                      onClick={closeForm}
                    >
                      {text.cancelButton}
                    </button>
                    <button type="submit" className="full-width-button">
                      {text.sendButton}
                    </button>
                  </div>
                </form>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default Message;
